import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useSaveDocRecommendationsMutation } from '../../redux/api/eegReportApi'

const AddRecommendationModal = ({ show, handleClose }) => {
  const [recommendation, setRecommendation] = useState('')

  const { selectedUser } = useSelector((state) => state.user)

  const [saveRecommendation, { isLoading, isError, error }] = useSaveDocRecommendationsMutation()

  const handleSave = async () => {
    await saveRecommendation({ userid: selectedUser?.id, recommended: recommendation })

    setRecommendation('')
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Enter Recommendation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId='prescriptionTextarea'>
            <Form.Label>Recommendation</Form.Label>
            <Form.Control
              as='textarea'
              rows={5}
              value={recommendation}
              onChange={(e) => setRecommendation(e.target.value)}
              placeholder='Enter the recommendation details here...'
            />
          </Form.Group>
          {isError && <div className='text-danger mt-2'>{error.message}</div>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button className='border px-3 py-1 bg-white rounded-pill' onClick={handleClose} disabled={isLoading}>
          Cancel
        </button>
        <button className='border-0 px-3 py-1 bg-primary text-white rounded-pill' onClick={handleSave} disabled={isLoading || !recommendation}>
          {isLoading ? 'Saving...' : 'Save'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddRecommendationModal
